<template>
<div class="w100">
    <b-row>
        <b-col cols="3" class="text-left">
            <p class="mr-10 lh-30 mb-0">{{ $t("messages.currentStatus") }}:</p>
         </b-col>
        <b-col cols="9" class="text-left">
            <b-button-group id="mode" class="menuOpt">
                <b-button class="optInt" style="margin:0px;" @click="uvInfo.modules.uv.status= 0" :pressed="uvInfo.modules.uv.status === 0">OFF</b-button>
                <b-button class="optInt" style="margin:0px;" @click="uvInfo.modules.uv.status = 1" :pressed="uvInfo.modules.uv.status === 1">ON</b-button>
             </b-button-group>
        </b-col>
    </b-row>
    <b-row style="margin-top:15px">
        <b-col cols="3" class="text-left">
            <p class="mr-10 lh-30 mb-0">{{ $t("messages.partialTime") }}:</p>
         </b-col>
        <b-col cols="9" class="text-left">
            <p>{{ getTime(uvInfo.modules.uv.partial) }}</p>
        </b-col>
    </b-row>
    <b-row>
        <b-col cols="3" class="text-left">
            <p class="mr-10 lh-30 mb-0">{{ $t("messages.totalTime") }}:</p>
         </b-col>
        <b-col cols="9" class="text-left">
            <p>{{ getTime(uvInfo.modules.uv.total)}}</p>
        </b-col>
    </b-row>
    <actions :has-changes="hasChanges" v-on:onSave="onSave" v-on:onCancel="onCancel"></actions>
</div>

</template>

<script>
import Actions from "./utils/Actions";

export default {
    name: 'Ultraviolet',
    components:{
        Actions
    },
    props: {
        poolId: Object
    },
    mounted() {
        let fresh = JSON.parse(JSON.stringify(this.poolId));
        this.uvInfo = fresh
        this.original = JSON.parse(JSON.stringify(fresh));
    },
    data() {
        return {
            hasChanges: false,
            original: null, 
            uvInfo: {
                'modules':{
                    'uv':{
                        'status': 0,
                    }
                }
            }
        }
    },

    watch: {
        'uvInfo': {
            handler(value) {
                this.hasChanges = (JSON.stringify(value) === JSON.stringify(this.original)) ? false : true
            },
            deep: true
        }
    },

    methods:{
        onSave () {
            this.$emit('onSave',this.original, this.uvInfo);
            this.original = JSON.parse(JSON.stringify(this.uvInfo));
            this.hasChanges = false
        },
        onCancel() {
            this.uvInfo = JSON.parse(JSON.stringify(this.original));
            this.hasChanges = false;
        },
        getTime: function(inputSeconds) {
            // return this.$moment.unix(value).utc().format("HH:mm");
            var sec_num = parseInt(inputSeconds, 10);
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);
            var hoursString = '';
            var minutesString = '';
            var secondsString = '';
            hoursString = (hours < 10) ? "0" + hours : hours.toString();
            minutesString = (minutes < 10) ? "0" + minutes : minutes.toString();
            secondsString = (seconds < 10) ? "0" + seconds : seconds.toString();
            return hoursString + ':' + minutesString + ':' + secondsString;
        }

    }
}
</script>


// WEBPACK FOOTER //
// src/components/Ultraviolet.vue